/* Built In Imports */

import { Box } from "@chakra-ui/react";
import TopBannerEvent from "@components/HeaderBanner/TopBannerEvent";
import { RenderFAQs } from "@components/UI/Common/SectionCommonUI";
import StyleConfig from "@components/UI/Common/StyleConfig";
import HowtoApply from "@landing_pages/hytt/sections/HowtoApply";
import HyttTestimonial from "../components/Testimonial/HyttTestimonial";
import FacilitiesAndInclusions from "../sections/FacilitiesAndInclusion";
import Offerings from "../sections/Offering";
import OtherAspects from "../sections/OtherAspects";
import PostProgram from "../sections/PostProgram";
import PracticeCurriculum from "../sections/PracticeCurriculum";
import ProgramFee from "../sections/ProgramFee";
import ProgramHighlights from "../sections/ProgramHighlights";
import SneakPeak from "../sections/SneakPeak";

/* External Imports */
// import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */

/**
 * Renders Render Sadhguru In Aus Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Sadhguru In Aus Sections
 */

const RenderSections = ({
    section,
    pageName,
    region,
    lang,
    pType,
    csrData,
    pageData,
    mode,
    formElement,
}) => {
    // console.log("The section is", section)
    const sectionId = section?.sectionId;
    if (sectionId === 'top-banner') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
                zIndex={"-10"}

            >
                <TopBannerEvent
                    pageData={pageData}
                    secImage={section?.sectionContent[1]}
                    sectionContent={section?.sectionContent[0]}
                    pageConfig={pageData?.pageConfig}
                />
            </StyleConfig >
        );
    }
    else if (sectionId === 'offerings') {
        return (

            <div style={{ position: 'relative' }}>
                <Box
                    background="#FFAE27"
                    zIndex="0"
                    clipPath={{ sm: "polygon(0 9%, 100% 0, 100% 100%, 0% 100%)", base: "polygon(0 9%, 100% 0, 100% 100%, 0% 100%)", md: "polygon(0 30%, 100% 0, 100% 100%, 70% 100%)" }}
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                />
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    pT="0"
                    pB="0"
                    // marginTop="-65px"
                    marginTop={{ base: "-65px", md: "-85px", xl: "-65px" }}
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                    // height="829px"
                    // polygon(0 0, 100% 8%, 100% 100%, 0% 100%)
                    background={{ base: "linear-gradient(#405C47 85%, #fff 0%)", md: "linear-gradient(#405C47 85%, #fff 0%)" }}
                    clipPath={{ sm: "polygon(0 0, 100% 3%, 100% 100%, 0% 100%)", base: "polygon(0 0, 100% 3%, 100% 100%, 0% 100%)", md: "polygon(0 0, 100% 8%, 100% 100%, 0% 100%)" }}
                >
                    <Offerings sectionContent={section?.sectionContent} />
                </StyleConfig >
            </div >
        );
    }
    if (sectionId === 'hytt-program-highlights') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
                zIndex={"-10"}
            >
                <ProgramHighlights pageData={pageData} pageConfig={pageData?.pageConfig} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'sneak-peak') {
        return (
            <div style={{ position: 'relative' }}>
                <Box
                    background="#FFAE27"
                    zIndex="-2"
                    clipPath={{ sm: " polygon(0 0, 100% 15%, 100% 100%, 0% 100%)", base: " polygon(0 0, 100% 15%, 100% 100%, 0% 100%)", md: "polygon(0 0, 100% 40%, 100% 100%, 0% 100%)" }}
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                />
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    // pT="0"
                    pB="0"
                    marginTop="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                    zIndex={10}
                    clipPath={{ base: "polygon(0 6%, 100% 0, 100% 100%, 0% 100%)", md: "polygon(0 6%, 100% 0, 100% 100%, 0% 100%)" }}
                >
                    <SneakPeak sectionContent={section?.sectionContent} />
                </StyleConfig>
            </div>
        );
    }
    else if (sectionId === 'practice-curriculum') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                style={section?.styleConfig}
                paddingBottom={{ sm: "50px", base: "50px", md: "40px" }}
                // height={{ sm: "", base: "650px", md: "750px" }}
                section={section}
            >
                <PracticeCurriculum pageData={pageData} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }

    else if (sectionId === 'post-program-support') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
            >
                <PostProgram sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'facilities-and-inclusions') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
            >
                <FacilitiesAndInclusions sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }

    else if (sectionId === 'other-aspects-of-training') {
        return (
            <div style={{ position: 'relative' }}>
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    pT="0"
                    pB="0"
                    marginTop="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                >
                    <Box
                        maxHeight={"753px"}
                        background="#FFAE27"
                        zIndex="-2"
                        clipPath={{ base: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)", sm: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)", md: "polygon(0 45%, 100% 0, 100% 100%, 0% 100%)" }}
                        // clipPath={"polygon(0 54%, 100% 0, 100% 100%, 0% 100%);"}
                        position="absolute"
                        top="0"
                        left="0"
                        right="0"
                        bottom="0"
                    />
                    <Box
                        // maxHeight={{ base: "778", sm: "778px", md: "753px" }}
                        zIndex={10}
                        background="#747474"
                        clipPath={{ base: " polygon(0 0, 100% 5%, 100% 100%, 0% 100%)", sm: " polygon(0 0, 100% 5%, 100% 100%, 0% 100%))", md: "polygon(0 0, 100% 10%, 100% 100%, 0% 100%)" }}
                        paddingBottom={{ base: "50px", sm: "50px", md: "0px" }}
                    >
                        <OtherAspects sectionContent={section?.sectionContent} />
                    </Box>
                </StyleConfig>
            </div >
        );
    }
    else if (sectionId === 'testimonial-ys') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
            >
                <Box
                    display="flex">
                    <HyttTestimonial
                        pageData={pageData}
                        sectionContent={section?.sectionContent}
                    />
                </Box>
            </StyleConfig>
        );
    }
    else if (sectionId === 'program-fee') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
            >
                <ProgramFee pageData={pageData} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'how-to-apply') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="30px"
                pB="30px"
                marginTop="0"
                mB="0"
                style={section.styleConfig}
                backgroundPosition="-1000px"
                backgroundRepeat="no-repeat"
            >
                <HowtoApply section={section} sectionContent={section?.sectionContent} region={region} lang={lang} />
            </StyleConfig>
        );
    }
    // else if (sectionId === 'talk-to-our-alumni') {
    //     return (
    //         <StyleConfig
    //             id={section.sectionId}
    //             key={section.sectionId}
    //             pT="30px"
    //             pB="30px"
    //             marginTop="0"
    //             mB="0"
    //             style={section.styleConfig}
    //         >
    //             <TalktoAlumni sectionContent={section?.sectionContent} region={region} lang={lang} formElement={formElement} />
    //         </StyleConfig>
    //     );
    // }
    else if (sectionId === 'faq-section') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
            ><Box margin={{ base: '', sm: "", md: "40px 0px" }}>
                    <RenderFAQs pageConfig={pageData?.pageConfig} section={section} />
                </Box>

            </StyleConfig>
        );
    }


};

export default RenderSections;
